import uniqueId from 'lodash/uniqueId';
import { HYDRATE } from 'next-redux-wrapper';

import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';

import { SECTIONS_COUNT } from '~/src/features/internetV2/constants';
import { EAction } from '~/src/features/internetV2/constants/actions';
import * as actions from '~/src/features/internetV2/store/actions';
import { InferValueTypes, THydrateAction } from '~/src/store';

export type TArticle = {
    key: string,
    id: number,
    question: string,
    answer: string,
    isOpen: boolean,
}

export type TSection = {
    key: string,
    visible: boolean,
};

export interface IInternetState {
    routers: IEquipment[],
    articles: Record<string, TArticle>,
    isLoading: boolean,
    sections: Record<string, TSection>,
}

const SECTIONS = Array.from({ length: SECTIONS_COUNT }, () => uniqueId())
    .reduce((acc, key) => {
        acc[key] = {
            visible: true,
            key,
        };
        return acc;
    }, {} as Record<string, TSection>);

export const initialState: IInternetState = {
    routers: [],
    articles: {},
    isLoading: false,
    sections: SECTIONS,
};

type TActions = ReturnType<InferValueTypes<typeof actions>> | THydrateAction;

const internetReducer = (state = initialState, action: TActions): IInternetState => {
    switch (action.type) {
        case HYDRATE:
            return {
                ...state,
                ...action.payload.internetReducer,
            };
        case EAction.SetLoading:
            return { ...state, isLoading: action.payload };
        case EAction.SetRouters:
            return { ...state, routers: action.payload };
        case EAction.SetArticles:
            return { ...state, articles: action.payload };
        case EAction.ToggleAnswer:
            return {
                ...state,
                articles: {
                    ...state.articles,
                    [action.payload.key]: {
                        ...action.payload,
                        isOpen: !action.payload.isOpen,
                    },
                },
            };
        case EAction.SetSectionVisibility: {
            const { key } = action.payload;

            return {
                ...state,
                sections: {
                    ...state.sections,

                    [key]: {
                        ...state.sections[key],
                        visible: action.payload.visible,
                    },
                },
            };
        }
        default:
            return state;
    }
};

export default internetReducer;
